/**
 * Attaches a custom event handler, allowing to execute code once a FEM event has triggered, even if the event has
 * completed before this handler got attached - thus fixing a possible race condition.
 *
 * @param eventName - name of the event to attach to
 * @param eventHandler - callback that will be triggered for the event
 */
export const attachEventHandlerWithFemFlagCheck = (
    eventName: string,
    eventHandler: (event: CustomEvent) => void
): void => {
    // Generate the flag name based on the event name
    const flagName = `femCe${
        eventName.charAt(0).toUpperCase() + eventName.slice(1)
    }Triggered`

    // Check if the flag is set
    if (
        Object.prototype.hasOwnProperty.call(window, flagName) &&
        (window as any)[flagName] === true
    ) {
        // Create a synthetic event with a custom property 'triggeredByFlag'
        const syntheticEvent = new CustomEvent(eventName, {
            detail: { triggeredByFlag: true }
        })
        // Execute the event handler with the synthetic event
        eventHandler(syntheticEvent)
    } else {
        // Attach the event handler
        document.addEventListener(eventName, eventHandler)
    }
}
